var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1948_4363",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1948_4363",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHdSURBVEiJtZW/SlxREMZ/3yr+CSpqGpEQiNhmiyVNhA3aRIg2SWWZpAr4EoIvYFgJpPAVsoUvIFgEgkhAOxEhxLSGaApFd1LcOevxrLvuXTcDw9w5M+f7zr0zcy5mxl0KLAGbwC/XTWCprb13AA8CVcBc/7oGvwoM3oeg4kDfgRmg4DrjawZUOiIAig7wAxi9JT4GHHtOsRlOgeZSdvvRzH6nQTM7AdaT3AZpRVB0u9ciZzfJzUXQ7/aiRc55kpuLoCvSmy5IGgaeAOO+NC2poQYh5nZcUhE4MrPTGxlRV0yQDVCN6z7PqzXHmAi4MjMk9QJfgWfAGbAFXOX5FEAPMAsMATvAczO7DKdf8BPsAyPtXAFNZmfEMQxYiOfgqdsNM/uT8+R18b0bMWYgGHB70il4JAFjICb4b3IrgaSCpIqkOffnJH2S1KNM1iS99FhJ0mdJD9omAEaB98C8+/PAO18f8tgrj71wf9L9b8AhsA0Qqr9CVvm3UUcMpx0SxyBr8TSWasMkB0knMu6uVrFUul5kSQ8lrUuaignCCR53geMDsAwsAvUalMlqcAyU7jHJJa7/cuX6XeSv9gV47af4SWd30SN/rprZm/obOEkfsAoc0NmNWvO9q0BfwP0HLVHzwIBgusoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.8431f73e5d30472405267158962daa1e.svg";
export { ForwardRef as ReactComponent };